import { Menus } from '@rocksoft/cdk';
import { Environment } from './environment.model';

const frontend = `${window.location.origin}/dev`;
const api = `https://api.rcksft.com/dev`;
export const environment: Environment = {
  production: true,
  local: false,
  appInsights: {
    instrumentationKey: '3bf7b312-3b82-4cf8-9c88-cb19cafbd279',
  },
  sentry: {
    enabled: true,
    dsn: 'https://8661ed4f66576e3d425ed189c4d69e6f@o4508284679094272.ingest.de.sentry.io/4510147887562832',
    environment: 'dev',
    release: '20260924.17-dev', // Will be replaced during build
    tracesSampleRate: 0.3,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    captureLogs: true,
  },
  appmanagement: {
    api: `${api}/appmanagement`,
  },
  locations: {
    api: `${api}/places`,
    enroll: `${api}/places`,
    qrForeground: '#27325E',
    pairUrl: `${frontend}/pair`,
  },
  settings: {
    api: `${api}/settings`,
  },
  groups: {
    api: `${api}/security`,
  },
  mdm: {
    api: `${api}/mdm`,
    frontend: `${frontend}/mdm`,
    deviceUrl: `${frontend}/mdm/devices`,
    enrollUrl: `${api}/mdm/apple/enroll`,
  },
  dep: {
    api: `${api}/dep`,
  },
  inroom: {
    api: `${api}/virtual-room`,
  },
  gateway: {
    api: `${api}/gateway`,
  },
  osupdates: {
    api: `${api}/os-updates`,
  },
  devicetaskmanagement: {
    api: `${api}/device-task-management`,
  },
  applesync: {
    api: `${api}/apple-sync`,
  },
  ireckonintegration: {
    api: `${api}/integrations/ireckon`,
  },
  oidc: [
    {
      configId: 'azureb2c-dev',
      authority: 'https://rcksftdev.b2clogin.com/rcksftdev.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN/v2.0',
      authWellknownEndpointUrl:
        'https://rcksftdev.b2clogin.com/rcksftdev.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN/v2.0/.well-known/openid-configuration',
      redirectUrl: frontend,
      postLogoutRedirectUri: frontend,
      clientId: 'bcda7878-6f98-40ff-92f6-e9d925fb5344',
      scope:
        'openid profile https://rcksftdev.onmicrosoft.com/api/os-updates https://rcksftdev.onmicrosoft.com/api/integrations https://rcksftdev.onmicrosoft.com/api/settings https://rcksftdev.onmicrosoft.com/api/security https://rcksftdev.onmicrosoft.com/api/mdm https://rcksftdev.onmicrosoft.com/api/virtual-room https://rcksftdev.onmicrosoft.com/api/gateway https://rcksftdev.onmicrosoft.com/api/places https://rcksftdev.onmicrosoft.com/api/appmanagement  https://rcksftdev.onmicrosoft.com/api/device-task-management https://rcksftdev.onmicrosoft.com/api/apple-sync',
      responseType: 'code',
      silentRenew: true,
      useRefreshToken: true,
      ignoreNonceAfterRefresh: true,
      maxIdTokenIatOffsetAllowedInSeconds: 600,
      issValidationOff: false, // this needs to be true if using a common endpoint in Azure
      autoUserInfo: false,
      domain_hint: null,
    },
  ],
  maximumSyncLoad: 250,
  features: {
    rooms: {
      guests: true,
      settings: {
        mdm: true,
        actions: true,
        permissions: true,
      },
      devices: true,
    },
    brands: {
      settings: {
        mdm: true,
        actions: true,
      },
    },
    locations: {
      enabled: true,
      settings: {
        mdm: true,
        actions: true,
        hotelinfo: true,
        permissions: true,
        osupdates: true,
      },
    },
    settings: {
      enabled: true,
    },
    devices: {
      enabled: true,
      swapped: true,
      reboot: true,
      healthOverview: true,
      details: {
        settings: {
          enabled: true,
        },
      },
      notes: {
        enabled: true,
      },
      assignmentHistory: {
        enabled: true,
      },
    },
    appmanagement: {
      enabled: true,
    },
    gateway: {
      enabled: true,
    },
    security: {
      enabled: true,
      operations: true,
    },
    deviceupdates: {
      enabled: true,
    },
    ireckon: {
      enabled: true,
    },
    virtual_room: {
      enabled: true,
    },
    housekeeping: {
      enabled: true,
    },
    staff: {
      enabled: true,
    },
    frontdesk: {
      enabled: true,
    },
    bar: {
      enabled: true,
    },
    kiosk: {
      enabled: true,
    },
    dep: {
      enabled: true,
    },
    management: {
      enabled: true,
    },
    appscheduling: {
      enabled: true,
    },
    vppappscheduling: {
      enabled: true,
    },
  },
};

export const appMenus: Menus = [
  { routerLink: 'places', title: 'Locations' },
  { routerLink: 'devices', title: 'Devices' },
  { routerLink: 'apps', title: 'Apps' },
  {
    routerLink: 'security',
    title: 'Security',
    children: [
      { routerLink: 'users', title: 'Users' },
      { routerLink: 'groups', title: 'Groups' },
    ],
  },
  {
    routerLink: 'mdm',
    title: 'MDM',
    children: [
      {
        routerLink: 'devices',
        title: 'Devices',
      },
      {
        routerLink: 'applications',
        title: 'Applications',
      },
      {
        routerLink: 'settings',
        title: 'Settings',
      },
      {
        routerLink: 'dep',
        title: 'DEP',
      },
    ],
  },
  { routerLink: 'virtual-room', title: 'Virtual Room' },
  {
    routerLink: 'management',
    title: 'Management',
    children: [
      {
        routerLink: 'vpp',
        title: 'VPP',
      },
      {
        routerLink: 'dep',
        title: 'DEP Token',
      },
      {
        routerLink: 'push',
        title: 'PUSH',
      },
      {
        routerLink: 'dep-certificate',
        title: 'DEP Certificate',
      },
      {
        routerLink: 'vendor',
        title: 'Vendor',
      },
    ],
  },
];

export const extModules = [];
